import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
export default {
  components: {HeadDetailsGama},
  name: 'SalesinformationAdm',
  props: ['selectedComissao']
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissions/components/salesinformationAdm/salesinformationAdm.js